module.exports = __webpack_public_path__ + "img/login-img.c60f8fa4.jpg";